import React, { useState, useEffect } from 'react';
import emailjs from 'emailjs-com';
import Navbar from '../Navbar/Navbar';
import Home from '../Home/Home';
import Side from '../SidePos/Side';
import { Helmet } from 'react-helmet';
import Swal from "sweetalert2";
import Modal from '../Modal/Modal';
import { MdSupportAgent } from "react-icons/md";
import { FaCarOn } from "react-icons/fa6";
import { GiReceiveMoney } from "react-icons/gi";
import Footer from '../Footer/Footer';
import SEOHelmet from '../SEOHelmet/SEOHelmet';
function Homepage() {
  const [showModal, setShowModal] = useState(false);
  const [formValues, setFormValues] = useState({
    name: '',
    email: '',
    mobile: '',
     option: ''
  });

  const [formErrors, setFormErrors] = useState({
    name: '',
    email: '',
    mobile: '',
     option: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setShowModal(true);
  }, []);

  const hideModal = () => {
    setShowModal(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
    validateField(name, value);
  };

  const validateField = (name, value) => {
    let errors = { ...formErrors };

    switch (name) {
      case 'name':
        errors.name = /^[a-zA-Z\s]*$/.test(value)
          ? ''
          : 'Name can only contain alphabets';
        break;
      case 'email':
        errors.email = /\S+@\S+\.\S+/.test(value)
          ? ''
          : 'Please enter a valid email address';
        break;
      case 'mobile':
        errors.mobile = /^\d{10}$/.test(value)
          ? ''
          : 'Mobile number must be 10 digits';
        break;
        case 'option':
  errors.option = value ? '' : 'Please select an option';
  break;

      default:
        break;
    }

    setFormErrors(errors);
  };

  const sendEmail = () => {
    emailjs.sendForm(
      'service_mshzku3',
      'template_lktgcfv',
      '#modal-form', 
      'hzdloJVjIk6jCAoRL'
    )
    .then((result) => {
      
      Swal.fire({
        title: "Form Submitted Successfully!",
        text: "Thanks you for expressing interest on our website our expert will get in touch with you shortly",
        imageUrl: "ty2.jpg",
        imageWidth: 400,
        imageHeight: 200,
        imageAlt: "Custom image",
      });
      hideModal();
      setIsSubmitting(false);
    }, (error) => {
   
      Swal.fire({
        title: "Oops!",
        text: "There was an error submitting the form. Please try again.",
        icon: "error"
      });
      setIsSubmitting(false);
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, mobile } = formErrors;

    if (!name && !email && !mobile) {
      setIsSubmitting(true);
      sendEmail();
    } else {
      alert('Please fix the errors in the form');
    }
  };

  return (
    <>
   
   <Helmet>
     {/* ----------------------------------------------------
        BASIC SEO TAGS
     ---------------------------------------------------- */}
     <title>Irish Platinum Sector 10 Greater Noida West | Luxury 3 & 4 BHK Apartments</title>
     <meta
       name="description"
       content="Irish Platinum at Sector 10 Greater Noida West offers premium 3 & 4 BHK luxury apartments with top-class amenities including all-weather swimming pool, high-speed elevators, gym, and more. Book a site visit for the best offers."
     />
     <meta
       name="keywords"
       content="Irish Platinum, Irish Platinum Sector 10 Greater Noida West, Irish Platinum Noida Extension, luxury apartments Greater Noida West, best residential project in Noida Extension, affordable apartments in Noida Extension, luxury apartments in Noida Extension, luxury apartments in Noida, 3 BHK Noida Extension, 4 BHK Noida Extension, Irish Group projects, Irish Platinum price list, Irish Platinum brochure, Irish Platinum amenities, new residential projects in Greater Noida West, premium flats in Noida Extension, ready to move apartments in Noida, upcoming projects in Noida Extension, high-rise apartments in Greater Noida West"
     />
     <link rel="canonical" href="https://irishplatinum.org/" />
     <meta name="robots" content="index, follow" />
     <meta name="theme-color" content="#ffffff" />
   
     {/* ----------------------------------------------------
        OPEN GRAPH TAGS
     ---------------------------------------------------- */}
     <meta property="og:title" content="Irish Platinum - Luxury 3 & 4 BHK Apartments in Greater Noida West" />
     <meta
       property="og:description"
       content="Explore Irish Platinum at Sector 10 Greater Noida West — Premium 3 & 4 BHK luxury residences with world-class amenities & modern lifestyle."
     />
     <meta property="og:image" content="https://irishplatinum.org/i1.webp" />
     <meta property="og:url" content="https://irishplatinum.org/" />
     <meta property="og:type" content="website" />
   
     {/* ----------------------------------------------------
        TWITTER META TAGS
     ---------------------------------------------------- */}
     <meta name="twitter:card" content="summary_large_image" />
     <meta name="twitter:title" content="Irish Platinum – Luxury 3 & 4 BHK Flats in Sector 10 Greater Noida West" />
     <meta
       name="twitter:description"
       content="Premium 3 & 4 BHK apartments with world-class amenities at Irish Platinum, Sector 10 Greater Noida West."
     />
     <meta name="twitter:image" content="https://irishplatinum.org/i1.webp" />
   
     {/* ----------------------------------------------------
        JSON-LD SCHEMA
     ---------------------------------------------------- */}
     <script
       type="application/ld+json"
       dangerouslySetInnerHTML={{
         __html: JSON.stringify({
           "@context": "https://schema.org",
           "@graph": [
             {
               "@type": "Organization",
               "name": "Irish Platinum",
               "url": "https://irishplatinum.org/",
               "logo": "https://irishplatinum.org/ico.png",
               "sameAs": ["https://irishplatinum.org/"],
               "contactPoint": [
                 {
                   "@type": "ContactPoint",
                   "telephone": "+919654945825",
                   "contactType": "Sales",
                   "areaServed": "IN",
                   "availableLanguage": ["English", "Hindi"]
                 }
               ],
               "founder": "Irish Group",
               "description": "Irish Platinum is a premium residential project offering luxury 3 & 4 BHK apartments in Sector 10 Greater Noida West with world-class amenities and excellent connectivity."
             },
             {
               "@type": "WebSite",
               "name": "Irish Platinum",
               "url": "https://irishplatinum.org/",
               "publisher": {
                 "@type": "Organization",
                 "name": "Irish Platinum",
                 "logo": {
                   "@type": "ImageObject",
                   "url": "https://irishplatinum.org/ico.png"
                 }
               },
               "potentialAction": {
                 "@type": "SearchAction",
                 "target": "https://irishplatinum.org/?q={search_term_string}",
                 "query-input": "required name=search_term_string"
               }
             },
             {
               "@type": "BreadcrumbList",
               "itemListElement": [
                 {
                   "@type": "ListItem",
                   "position": 1,
                   "name": "Home",
                   "item": "https://irishplatinum.org/"
                 }
               ]
             },
             {
               "@type": "ApartmentComplex",
               "name": "Irish Platinum",
               "url": "https://irishplatinum.org/",
               "description": "Irish Platinum is a premium residential project offering ultra-luxury 3 & 4 BHK apartments at Sector 10 Greater Noida West. Land area: 5 acres, 4 towers, 570 units, G+29 floors, all weather swimming pool, kids pool, gym, squash court, badminton court, jogging track, and high-speed elevators.",
               "slogan": "Premium 3 & 4 BHK Luxury Apartments in Noida Extension",
               "image": [
                 "https://irishplatinum.org/i11.webp",
                 "https://irishplatinum.org/i1.webp",
                 "https://irishplatinum.org/am.JPG",
                 "https://irishplatinum.org/ico.png"
               ],
               "address": {
                 "@type": "PostalAddress",
                 "streetAddress": "GH-04A, near Arihant Abode, Sector 10, Vaidpura",
                 "addressLocality": "Greater Noida West",
                 "addressRegion": "Uttar Pradesh",
                 "postalCode": "203207",
                 "addressCountry": "IN"
               },
               "telephone": "+919654945825",
               "numberOfBuildings": 4,
               "numberOfRoomsTotal": 570,
               "floorCount": 29,
               "petsAllowed": false,
               "tourBookingPage": "https://irishplatinum.org/",
               "amenityFeature": [
                 { "@type": "LocationFeatureSpecification", "name": "All Weather Swimming Pool" },
                 { "@type": "LocationFeatureSpecification", "name": "All Weather Kids Pool" },
                 { "@type": "LocationFeatureSpecification", "name": "Interactive Fountains with Sit-out Area" },
                 { "@type": "LocationFeatureSpecification", "name": "Loungers Under Garden Umbrella" },
                 { "@type": "LocationFeatureSpecification", "name": "11 Feet Ceiling Height" },
                 { "@type": "LocationFeatureSpecification", "name": "Pathway / Jogging Track" },
                 { "@type": "LocationFeatureSpecification", "name": "Indoor Gym" },
                 { "@type": "LocationFeatureSpecification", "name": "Outdoor Gym" },
                 { "@type": "LocationFeatureSpecification", "name": "Badminton Court" },
                 { "@type": "LocationFeatureSpecification", "name": "Squash Court" },
                 { "@type": "LocationFeatureSpecification", "name": "Kids Play Area" },
                 { "@type": "LocationFeatureSpecification", "name": "24x7 Security" },
                 { "@type": "LocationFeatureSpecification", "name": "Elegant Floor Lobbies" },
                 { "@type": "LocationFeatureSpecification", "name": "4 - 6 High Speed Elevators" }
               ],
               "geo": {
                 "@type": "GeoCoordinates",
                 "latitude": "28.607407",
                 "longitude": "77.428009"
               },
               "additionalProperty": [
                 { "@type": "PropertyValue", "name": "RERA Number", "value": "UPRERAPRJ503189/03/2024" },
                 { "@type": "PropertyValue", "name": "Land Area", "value": "5 Acres" },
                 { "@type": "PropertyValue", "name": "Total Towers", "value": "4" },
                 { "@type": "PropertyValue", "name": "Total Units", "value": "570" },
                 { "@type": "PropertyValue", "name": "Total Floors", "value": "G+29" }
               ]
             },
             {
               "@type": "OfferCatalog",
               "name": "Irish Platinum Price List",
               "url": "https://irishplatinum.org/",
               "itemListElement": [
                 { "@type": "Offer", "name": "3 BHK 1390 sq.ft (2 Toilets, 4 Balconies)", "price": "On Request", "priceCurrency": "INR" },
                 { "@type": "Offer", "name": "3 BHK 1690 sq.ft (3 Toilets, 4 Balconies)", "price": "On Request", "priceCurrency": "INR" },
                 { "@type": "Offer", "name": "3 BHK 1925 sq.ft (4 Toilets, 4 Balconies)", "price": "On Request", "priceCurrency": "INR" },
                 { "@type": "Offer", "name": "4 BHK 2150 sq.ft (4 Toilets, 4 Balconies)", "price": "On Request", "priceCurrency": "INR" },
                 { "@type": "Offer", "name": "4 BHK 2550 sq.ft (5 Toilets, 4 Balconies)", "price": "On Request", "priceCurrency": "INR" }
               ]
             },
             {
               "@type": "ContactPage",
               "url": "https://irishplatinum.org/",
               "name": "Irish Platinum Sales Inquiry",
               "telephone": "+919654945825",
               "contactType": "Sales Inquiry",
               "description": "Contact Irish Platinum for booking, price details, brochure, site visit and virtual tour.",
               "provider": {
                 "@type": "RealEstateAgent",
                 "name": "Authorized Channel Partner - Shishir",
                 "identifier": "UP RERA Registration No. UPRERAAGT24002"
               }
             }
           ]
         })
       }}
     />
   </Helmet>
      <Modal show={showModal} handleClose={hideModal}>
        <div className='modal-full'>
          <div className='modalleft'>
            <h4 className='modal-heading'>We Promise</h4>
            <div className='modal-logo-left'>
              <MdSupportAgent className='modal-logo1'/>
              <p className='modal-sub-heading'>Instant Call Back</p>
            </div>
            <div className='modal-logo-left'>
              <FaCarOn className='modal-logo1'/>
              <p className='modal-sub-heading'>Free Site Visit</p>
            </div>
            <div className='modal-logo-left'>
              <GiReceiveMoney className='modal-logo1'/>
              <p className='modal-sub-heading'>Unmatched Price</p>
            </div>
          </div>
          <div className='modalright'>
            <h2 className="modal-heading">IRISH PLATINUM</h2>
            <p className='modal-sub-heading'>At Sector 10, Greater Noida West</p>
            <form id="modal-form" className="modal-form" onSubmit={handleSubmit}>
  <div className="form-group">
    <label htmlFor="name">Name:</label>
    <input
      type="text"
      id="name"
      name="name"
      value={formValues.name}
      onChange={handleChange}
      required
    />
    {formErrors.name && <p className="error">{formErrors.name}</p>}
  </div>

  <div className="form-group">
    <label htmlFor="email">Email:</label>
    <input
      type="email"
      id="email"
      name="email"
      value={formValues.email}
      onChange={handleChange}
      required
    />
    {formErrors.email && <p className="error">{formErrors.email}</p>}
  </div>

  <div className="form-group">
    <label htmlFor="mobile">Mobile:</label>
    <input
      type="tel"
      id="mobile"
      name="mobile"
      value={formValues.mobile}
      onChange={handleChange}
      required
    />
    {formErrors.mobile && <p className="error">{formErrors.mobile}</p>}
  </div>

  {/* ⭐ NEW UNIT DROPDOWN ADDED ⭐ */}
 <div className="form-group">
  <label htmlFor="option">Property Type</label>
  <select
    id="option"
    name="option"
    required
    onChange={handleChange}
    className="select-input"
  >
    <option value="">Select Property Type</option>

    <option value="3 BHK – 1390 sq.ft ">
      3 BHK – 1390 sq.ft 
    </option>

    <option value="3 BHK – 1690 sq.ft ">
      3 BHK – 1690 sq.ft 
    </option>

    <option value="3 BHK – 1925 sq.ft ">
      3 BHK – 1925 sq.ft 
    </option>

    <option value="4 BHK – 2150 sq.ft ">
      4 BHK – 2150 sq.ft 
    </option>

    <option value="4 BHK – 2550 sq.ft ">
      4 BHK – 2550 sq.ft 
    </option>
  </select>
</div>


  <div className="butt-f">
    <button
      className="submit-button-f"
      type="submit"
      disabled={isSubmitting}
    >
      {isSubmitting ? 'Submitting...' : 'Get Instant Call back'}
    </button>
  </div>
</form>

          </div>
        </div>
      </Modal>
      <Navbar />
      <Side />
      <Home />
      <Footer/>
    </>
  );
}

export default Homepage;
